import { useSelector } from 'react-redux';
import config from 'config';

import { useExpBackoff } from './expBackoff';
import { getHttpErrorCode } from './error';
import { VideoCtvRedux } from '../store-types';
import { ApiError } from 'app-types';

const maxInterval = config.api.maxRetryFallbackMs;
const defaultErrorCodes = [429];

export const useScalingRetryInterval = (
  initInterval: number,
  retryErrorCodes?: number[],
) => {
  const globalSettings = useSelector(
    (state: VideoCtvRedux) => state.kitchenSink.data?.globalSettings,
  );

  const { val: interval, increase, reset } = useExpBackoff(
    initInterval,
    globalSettings?.max429RetryMs || maxInterval,
  );

  const onErrorChange = (error: unknown) => {
    if (error) {
      const errorCode = getHttpErrorCode(error as ApiError);
      const codesToCheck = retryErrorCodes || defaultErrorCodes;
      if (codesToCheck.includes(errorCode)) {
        increase();
      } else {
        reset();
      }
    }
  };

  return { interval, resetInterval: reset, onErrorChange };
};